class GhostListController {
    constructor(breakpointsService) {
        this.breakpointsService = breakpointsService;
    }
}

GhostListController.$inject = ['BreakpointsService'];

const ghostListComponentDefinition = {
    controller: GhostListController,
    template: require('./ghost-list.component.html').trim(),
};

module.exports = {
    GhostListController,
    ghostListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/ghost-list.component.js